module.exports = __webpack_public_path__ + "img/ppt版_00.583d993a.png";